import { przezmorzeApi } from "../../api/api";
import type { ExchangeRateBaseCurrency, ExchangeRatesResponse } from "@przezmorze/api-types";

export type { ExchangeRateBaseCurrency, ExchangeRatesResponse };

export async function getLatestExchangeRates(
  baseCurrency: ExchangeRateBaseCurrency,
  abortSignal?: AbortSignal,
): Promise<ExchangeRatesResponse> {
  const response = await przezmorzeApi.get<ExchangeRatesResponse>(`exchange-rates/${baseCurrency}/latest`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function getExchangeRatesFor(
  baseCurrency: ExchangeRateBaseCurrency,
  date: string,
  abortSignal?: AbortSignal,
): Promise<ExchangeRatesResponse> {
  const response = await przezmorzeApi.get<ExchangeRatesResponse>(`exchange-rates/${baseCurrency}/${date}`, {
    signal: abortSignal,
  });
  return response.data;
}
